import Wrap from '@/components/Wrap.vue'

const routers = [{
  index: 11,
  path: '/operation',
  name: 'operation',
  text: '手术一览',
  menu: true,
  permission: '_hasorg',
  hasChildren: false,
  redirect: '/operation/arrange',
  component: Wrap,
  children: [{
    path: '/operation/arrange',
    name: 'operation_arrange',
    text: '手术排班',
    menu: false,
    component: resolve => require(['../views/operation/Arrange'], resolve)
  }, {
    path: '/operation/approve',
    name: 'operation_approve',
    text: '手术审批',
    menu: false,
    component: resolve => require(['../views/operation/Approve'], resolve)
  }, {
    path: '/operation/history',
    name: 'operation_history',
    text: '历史手术',
    menu: false,
    component: resolve => require(['../views/operation/History'], resolve)
  }]
}, /*{
  index: 31,
  path: '/potential',
  name: 'potential',
  text: '档案管理',
  menu: true,
  permission: 'per_patient_001001',
  hasChildren: false,
  redirect: '/potential/symptom',
  component: Wrap,
  children: [{
    path: '/potential/symptom',
    name: 'potential_symptom',
    text: '病症列表',
    menu: false,
    component: resolve => require(['../views/potential/symptom'], resolve)
  }, {
    path: '/potential/symptomShow/:id',
    name: 'potential_symptomShow',
    text: '病症详情',
    menu: false,
    component: resolve => require(['../views/potential/symptom-show'], resolve)
  }]
  },*/{
    index: 41,
    path: '/dashboard',
    name: 'dashboard',
    text: '统计分析',
    menu: true,
    permission: 'per_count',
    hasChildren: false,
    component: resolve => require(['../views/Dashboard'], resolve)
  }]

export default routers
